import React from "react";
import '../assets/Lonavalley.css';
import lonavalleyHero from '../assets/imgs/Lonavalley/lonavala-uskan-dam.webp';
import lonavalley2 from '../assets/imgs/Lonavalley/lonavalley-2.webp';
import lonavalley3 from '../assets/imgs/Lonavalley/lonavalley-3.webp';

function Lonavalley() {
    return (

        <>
            <div className="lonavalley-outer-container">
                <div className="lonavalley-hero">
                    <img src={lonavalleyHero} loading="lazy"></img>

                </div>
            </div>



        </>

    );
}

export default Lonavalley;
